import { type TObjectType, type TObjectTypePermissions } from "types/authorization";
import { apiReq } from "utils/api/apiReq";

export interface IAuthorizationResponse<T extends TObjectType = TObjectType> {
  objectId: string;
  objectType: T;
  permissions: TObjectTypePermissions<T>;
}

export const getObjectPermissions = async <T extends TObjectType>(
  objectType: T,
  objectId: string,
): Promise<IAuthorizationResponse<T>> => {
  const { data } = await apiReq<IAuthorizationResponse<T>>(
    "GET",
    `/v1/authorization/${objectType}/${objectId}/permissions`,
  );
  return data;
};
